module.exports = __webpack_public_path__ + "img/image01.e4032ef1.jpg";